import { render, staticRenderFns } from "./WifiVouchers.vue?vue&type=template&id=24ee5e6b&"
import script from "./WifiVouchers.vue?vue&type=script&lang=js&"
export * from "./WifiVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports